import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { MaterialUITableDataItem } from "./types";

interface MaterialUITableProps {
  data: MaterialUITableDataItem[];
  insideForm?: boolean | false;
  submitMethod?: any;
}

export const MaterialUITable = ({ data, insideForm, submitMethod }: MaterialUITableProps) => {
  // Extract column headers dynamically
  const columns: string[] = data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <Box sx={{ marginLeft: "5px", marginRight: "5px" }}>
      <form onSubmit={submitMethod}>
        <TableContainer component={Paper}>
          <Table
            sx={{
              tableLayout: "auto",
              "& .MuiTableCell-root": {
                border: "1px solid rgba(224, 224, 224, 1)",
              },
            }}
          >
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={col} sx={{ fontWeight: "bold", fontSize: { xs: "0.85rem", md: "1rem" } }}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, rowIndex) => (
                <TableRow key={rowIndex} sx={{ backgroundColor: rowIndex % 2 === 0 ? "#f5f5f5" : "white" }}>
                  {columns.map((col) => (
                    <TableCell key={col} sx={{ fontSize: { xs: "0.75rem", md: "1rem" } }}>
                      {row[col]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {insideForm ? (
          <Box sx={{ textAlign: "center", margin: "10px" }}>
            <Button type="submit" variant="contained" color="primary" size="small">
              Submit
            </Button>
          </Box>
        ) : (
          ""
        )}
      </form>
    </Box>
  );
};
